import { Injectable, NgZone } from '@angular/core';
import { Payment } from 'utils/interfaces';
import { HttpService } from 'services/http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class StripeService {
  private stripe;
  private stripeElemets;
  private cardElement;

  constructor(private http: HttpService, private zone: NgZone) {
    this.stripe = new (window as any).Stripe(environment.stripeKey);
    this.stripeElemets = this.stripe.elements();
    this.cardElement = this.stripeElemets.create('card', {
      hidePostalCode: true,
      style: {
        base: {
          iconColor: '#666EE8',
          color: '#31325F',
          lineHeight: '40px',
          fontWeight: 300,
          fontFamily: '"Noto sans", Helvetica, sans-serif',
          fontSize: '14px',

          '::placeholder': {
            color: '#CFD7E0',
          },
        },
      },
      classes: {
        focus: 'is-focused',
      },
    });
  }

  getCardElement() {
    return this.cardElement;
  }

  pay(url: string, payment: Payment) {
    return this.http.post(url, payment);
  }

  getPaymentToken(cardElement, extras) {
    return this.zone.run(() => this.stripe.createToken(cardElement, extras));
  }
}
